import styled from 'styled-components';

const P = styled.p`
  color: rgba(232, 230, 227, 0.84);
  display: block;
  font-size: 1.6em;
  margin: 50px 0 0 0;
  text-align: center;
`;

export default P;